import { PropertyType, ToolProvider } from '@/backend/types'
import { defaultToolConfig } from '@/modules/Project/Tools/tool-config-presets'
import type { ToolRegistryItem } from '@/modules/Project/Tools/tool-types'

export const claude35HaikuTool: ToolRegistryItem = {
  ...defaultToolConfig,
  label: 'Claude 3.5 Haiku',
  addedAt: new Date('2024-01-01'),
  description: 'The next generation of the fastest model in the Claude family.',
  outputTypes: [
    PropertyType.text,
    PropertyType.single_select,
    PropertyType.multi_select,
    PropertyType.json,
    PropertyType.collection,
    PropertyType.url,
  ],
  provider: ToolProvider.anthropic,
  icon: 'company-anthropic',
}
